import { TableFieldModel } from '@/model/TableList'
import $currency from 'currency.js'

interface InvoiceDetail {
  no?: string;
  code?: string;
  checkCode?: string;
  amount: number;
  date?: string;
  type?: string;
  createTime: string;

  [key: string]: any;
}

interface InvoicePageModel {

  details?: InvoiceDetail[];

  [key: string]: any;
}

export const TableField: TableFieldModel<InvoicePageModel>[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '开票编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyName',
    fieldName: '客户公司'
  },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'titleName',
    fieldName: '发票抬头'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '金额',
    isMoney: true,
    textAlign: 'right',
    width: 130
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'rate',
    fieldName: '税率',
    width: 110
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketNo',
    fieldName: '发票号码',
    width: 150,
    convert: context => context.rowData.details?.map((item) => item.no ?? '空').join(',') ?? ''
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'ticketCode',
  //   fieldName: '发票代码',
  //   width: 150,
  //   convert: context => context.rowData.details?.map((item) => item.code ?? '空').join(',') ?? ''
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'ticketCheckCode',
  //   fieldName: '发票检查码',
  //   width: 150,
  //   convert: context => context.rowData.details?.map((item) => item.checkCode ?? '空').join(',') ?? ''
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketAmount',
    fieldName: '发票金额',
    width: 150,
    convert: context => context.rowData.details?.map((item) => $currency(item.amount)).join(',') ?? ''
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketDate',
    fieldName: '开票时间',
    width: 150,
    convert: context => context.rowData.details?.map((item) => item.date ?? '空').join(',') ?? ''
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'ticketCreateDate',
    fieldName: '登记时间',
    width: 150,
    convert: context => context.rowData.details?.map((item) => item.createTime ?? '空').join(',') ?? ''
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'title',
    fieldName: '所属公司'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'taxId',
    fieldName: '税号'
  },
  {
    componentType: 'el-textarea',
    componentName: '输入框',
    fieldKey: 'mark',
    fieldName: '备注'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'bank',
    fieldName: '开户银行'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'account',
    fieldName: '银行账号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'registeredAddress',
    fieldName: '注册地址'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'phone',
    fieldName: '电话号码',
    width: 140
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'statusValue',
    fieldName: '状态',
    width: 100
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUserName',
    fieldName: '创建人',
    width: 110
  },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'orderNo',
  //   fieldName: '订单号',
  //   width: 150,
  //   convert: context => {
  //     const { rowData = {}} = context
  //     const { businessList = [] } = rowData
  //     const orderList = [] as any
  //     businessList.forEach((kk: any) => {
  //       const isExist = orderList.find((item: any) => item.id === kk.order.id)
  //       if (!isExist) {
  //         orderList.push(kk.order)
  //       }
  //     })
  //     return orderList.map((kk: any) => kk.no).join(',')
  //   }
  // },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerNo',
    fieldName: '订单号',
    width: 150,
    convert: context => {
      const { rowData = {}} = context
      const { businessList = [] } = rowData
      const orderList = [] as any
      businessList.forEach((kk: any) => {
        const isExist = orderList.find((item: any) => item.id === kk.order.id)
        if (!isExist) {
          orderList.push(kk.order)
        }
      })
      return orderList.map((kk: any) => kk.customerNo).join(',')
    }
  }
]
